import client from '@atom/graph/client';
import configuration from '@atom/utilities/configuration';
import { redirectDomain, subdomain } from '@atom/utilities/endpoints';
import { instantiateFullStory } from '@atom/utilities/fullstoryUtilities';

import { configureStore } from './store/configureStore';
import Root from './Root';
import rootSaga from './sagas';

import './styles/colors.css';
import './styles/fonts.css';
import './styles/layout.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './styles/override/calendar.css';

if (configuration.environment === 'production') {
  instantiateFullStory();
}

const store = configureStore();

store.runSaga(rootSaga);

// If a user lands on the subdomainless page, they will be redirected
// to the www domain.
if (!subdomain) {
  window.location.replace(redirectDomain);
}

if (configuration.env === configuration.constants.LOCAL) {
  document.title = `LOCAL - ${document.title}`;
} else if (configuration.env === configuration.constants.DEV) {
  document.title = `DEVELOPMENT - ${document.title}`;
} else if (configuration.env === configuration.constants.QA) {
  document.title = `QA - ${document.title}`;
} else if (configuration.env === configuration.constants.UAT) {
  document.title = `UAT - ${document.title}`;
}

Root.initializeApplication(store, client);
